import { CoreApplicationContext } from '@eventbrite/context-gen';
import { Layout } from '@eventbrite/eds-layout';
import { setLanguage } from '@eventbrite/i18n';
import { configureStore } from '@eventbrite/redux-configure-store';
import { middleware as resourceCacheMiddleware } from '@eventbrite/resource-cache';
import { SiteStructure } from '@eventbrite/site-structure';
import { useConstructor } from '@eventbrite/use-constructor';
import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import Page from './pages/Page';
import reducer from './reducers/index';
import { getInitialState } from './utils';

export interface AppProps {
    officeTLD: string;
    featureFlags: any;
}

export const App: React.FC<AppProps & CoreApplicationContext> = ({
    env,
    officeTLD,
    request,
    user,
    footerLinks,
    featureFlags,
}) => {
    const store = configureStore({
        reducer,
        middleware: [thunk, resourceCacheMiddleware],
        initialState: getInitialState(env, officeTLD),
    });

    useConstructor(() => {
        setLanguage(env.localeInfo.locale);
    });

    return (
        <SiteStructure
            env={env}
            officeTLD={officeTLD}
            request={request}
            user={user}
            footerLinks={footerLinks}
            fullScreenMain={true}
            showMarketingLinks={true}
            featureFlags={featureFlags}
        >
            <Layout maxWidth="large" hasHorizontalGutters={true}>
                <Provider store={store}>
                    <Page />
                </Provider>
            </Layout>
        </SiteStructure>
    );
};
